<script lang="ts">
import { defineComponent } from 'vue';
import Notify from '~/widgets/Notify';
import GroupTrackersConfigApiClient from '~/apiClients/GroupTrackersConfigApiClient';
import BaseConfigurationPublisher from './BaseConfigurationPublisher.vue';
import PublishButtonStatusUpdate from '../../windowEvents/PublishButtonStatusUpdate';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'TemplateConfigurationPublisher',
  extends: BaseConfigurationPublisher,
  data() {
    return {
      title: 'Publish templates configuration',
    };
  },
  setup() {
    const route = useRoute();
    return {
      getRouteParam: (name: string) => route.params[name]
    };
  },
  computed: {
    templateId(): number {
      return Number(this.getRouteParam('id'));
    },
  },
  beforeMount() {
    window.addEventListener(PublishButtonStatusUpdate.EVENT_TYPE, this.setButtonStatus);
  },
  async mounted() {
    await this.setButtonStatus();
  },
  beforeUnmount() {
    window.removeEventListener(PublishButtonStatusUpdate.EVENT_TYPE, this.setButtonStatus);
  },
  methods: {
    getApiClient(): GroupTrackersConfigApiClient {
      return new GroupTrackersConfigApiClient();
    },
    async runPublishing(): Promise<void> {
      const ghs = await this.getApiClient().provideGroupHashesForUnpublishedTemplate(this.templateId);
      this.totalGroups = ghs.length;
      if (this.totalGroups === 0) {
        Notify.success(`No configurations to publish`);
      }

      for (const gh of ghs) {
        await this.publishForGroup(gh);
        this.completedGroups++;
      }
      await this.setButtonStatus();
    },
    async publishForGroup(gh: string): Promise<void> {
      try {
        await this.getApiClient().publish(false, gh);
        Notify.success(`Templates configuration for group ${gh} has been published successfully`, { fadeOut: { delay: 2000 } });
      } catch (e) {
        Notify.error(`Failed to publish configuration for group ${gh}... ${e.response?.data}`, { fadeOut: { enabled: false } });
      }
    },
    async setButtonStatus() {
      this.isButtonDisabled = await this.getApiClient().getTemplateIsPublishedStatus(this.templateId);
    },
  },
});
</script>
